import axios from 'axios';

// Pega a URL do ambiente ou usa o localhost, mas SEMPRE adiciona '/api' no final
const baseURL = (process.env.REACT_APP_API_URL || 'http://localhost:10000') + '/api';

const api = axios.create({
    baseURL: baseURL
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.clear();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;